var map = {
	"./accessibility.svg": 11790,
	"./add-column.svg": 44001,
	"./add-subpage.svg": 80247,
	"./add-topic.svg": 11208,
	"./add-user-outline.svg": 41894,
	"./add-user.svg": 36486,
	"./address-book.svg": 45430,
	"./alarm-off.svg": 81901,
	"./alarm.svg": 32097,
	"./album.svg": 78689,
	"./alert-circle-outline.svg": 56834,
	"./alert-circle.svg": 46026,
	"./align-3-top.svg": 29531,
	"./align-center.svg": 79610,
	"./align-justify.svg": 6077,
	"./align-left.svg": 43311,
	"./align-right.svg": 50457,
	"./all-users.svg": 32639,
	"./analytics.svg": 3858,
	"./anchor.svg": 22436,
	"./animation-fast.svg": 97138,
	"./apps.svg": 91553,
	"./armchair.svg": 1695,
	"./arrow-bold-down.svg": 73296,
	"./arrow-bold-left.svg": 13515,
	"./arrow-bold-right.svg": 29392,
	"./arrow-bold-up.svg": 19203,
	"./arrow-down-circle.svg": 86847,
	"./arrow-down-outline.svg": 60041,
	"./arrow-down.svg": 41049,
	"./arrow-left.svg": 53404,
	"./arrow-right.svg": 65824,
	"./arrow-rotate-clockwise.svg": 97428,
	"./arrow-rotate-left.svg": 46404,
	"./arrow-turn-up.svg": 35582,
	"./arrow-up-outline.svg": 83705,
	"./arrow-up-right.svg": 13586,
	"./ascending-sorting.svg": 89730,
	"./assign.svg": 58269,
	"./at-sign.svg": 56180,
	"./audio.svg": 89006,
	"./avatar-upload.svg": 14118,
	"./award.svg": 46251,
	"./backpack.svg": 60773,
	"./badge-check.svg": 96985,
	"./bag.svg": 36803,
	"./ball-rugby.svg": 23502,
	"./ball-volleyball.svg": 7793,
	"./ban.svg": 8842,
	"./bandage.svg": 88156,
	"./barbell.svg": 54718,
	"./bars-filter.svg": 7663,
	"./beaker.svg": 96807,
	"./bell-slash.svg": 81443,
	"./bicycle.svg": 9642,
	"./billing.svg": 21058,
	"./board-illustration.svg": 97254,
	"./bold.svg": 77374,
	"./bolt.svg": 89861,
	"./book-2.svg": 13670,
	"./book-bookmark.svg": 92444,
	"./book-outline.svg": 12470,
	"./bookmark.svg": 64494,
	"./bookmarks.svg": 37294,
	"./box-archive.svg": 63040,
	"./bracket.svg": 51817,
	"./briefcase.svg": 85349,
	"./brush.svg": 51365,
	"./bug.svg": 86880,
	"./bullhorn.svg": 31179,
	"./business-plan.svg": 35651,
	"./calendar-alert-2.svg": 89796,
	"./calendar-check.svg": 91792,
	"./calendar-event.svg": 32748,
	"./calendar-illustration.svg": 14647,
	"./calendar-next-week.svg": 90704,
	"./calendar-outline.svg": 16163,
	"./calendar-overdue.svg": 58856,
	"./calendar-planning.svg": 23434,
	"./calendar-this-weekend.svg": 75007,
	"./calendar-today.svg": 22214,
	"./calendar-tomorrow.svg": 77780,
	"./calendar-two-weeks.svg": 70121,
	"./calendar-upcoming.svg": 22506,
	"./calendar-xmark.svg": 47145,
	"./call-outline.svg": 1848,
	"./call.svg": 1931,
	"./calls-talking.svg": 64325,
	"./camera.svg": 19424,
	"./cancel-reminder.svg": 28607,
	"./cannot-be-found.svg": 52650,
	"./canva.svg": 88619,
	"./caption.svg": 97969,
	"./car.svg": 58003,
	"./card.svg": 81810,
	"./caret-down-circle-outline.svg": 1998,
	"./caret-down.svg": 61308,
	"./caret-right.svg": 11969,
	"./caret-up-circle-outline.svg": 80411,
	"./caret-up.svg": 83744,
	"./celebrate.svg": 10630,
	"./center-alignment.svg": 83977,
	"./chat-bubble.svg": 821,
	"./chat-join.svg": 18582,
	"./chat-outline.svg": 45193,
	"./chat-talking.svg": 72776,
	"./chat.svg": 84846,
	"./checkbox-checked.svg": 47984,
	"./checkbox.svg": 89562,
	"./checkmark.svg": 75991,
	"./chevron-down-outline.svg": 67750,
	"./chevron-down.svg": 21362,
	"./chevron-left.svg": 57323,
	"./chevron-right.svg": 74477,
	"./chevron-up.svg": 34721,
	"./circle-check-fill.svg": 54626,
	"./circle-check-outline.svg": 42691,
	"./circle-compose.svg": 38584,
	"./circle-dashed.svg": 69123,
	"./circle-hashtag.svg": 46435,
	"./circle-info.svg": 23702,
	"./circle-minus.svg": 66749,
	"./circle-open-arrow-up-right.svg": 74740,
	"./circle-outline.svg": 83499,
	"./circle-user-plus.svg": 23301,
	"./circle-user.svg": 27448,
	"./circle-xmark.svg": 52267,
	"./circle.svg": 8048,
	"./clear-all.svg": 82092,
	"./clear.svg": 14397,
	"./clipboard-list.svg": 51113,
	"./clipboard.svg": 53531,
	"./clock-outline.svg": 8678,
	"./clock-plus.svg": 62803,
	"./clock-rotate-clockwise.svg": 14067,
	"./clock.svg": 82919,
	"./cloud-download.svg": 21894,
	"./cloud-fill.svg": 9208,
	"./cloud-upload.svg": 58917,
	"./cloud.svg": 79841,
	"./code-pull-request.svg": 86330,
	"./code.svg": 67279,
	"./codepen.svg": 87873,
	"./cog.svg": 62420,
	"./cognito-forms.svg": 37964,
	"./collapse.svg": 37296,
	"./color-icons.svg": 9871,
	"./color-palette.svg": 22595,
	"./column-after.svg": 6170,
	"./column-before.svg": 10537,
	"./command-k.svg": 83961,
	"./command.svg": 33284,
	"./compose-2.svg": 81533,
	"./compose.svg": 15991,
	"./computer-1.svg": 6306,
	"./computer.svg": 82349,
	"./confirm-pasword.svg": 99870,
	"./contact-sales.svg": 19378,
	"./contact-support.svg": 95879,
	"./control.svg": 79618,
	"./copies-2.svg": 23747,
	"./copy-outline.svg": 88330,
	"./cover-photo.svg": 92945,
	"./cover.svg": 36442,
	"./create-new-task.svg": 8691,
	"./created-date.svg": 69384,
	"./created.svg": 34789,
	"./credit-card.svg": 18316,
	"./crop-rotate.svg": 21679,
	"./cube.svg": 9735,
	"./cubes.svg": 21186,
	"./currency-type.svg": 2798,
	"./current-day-calendar.svg": 30864,
	"./cursor-default.svg": 25456,
	"./cursor-grabbed.svg": 65930,
	"./dash-divider.svg": 91399,
	"./data-sources-outline.svg": 78330,
	"./default.svg": 52672,
	"./descending-sorting.svg": 70044,
	"./directions.svg": 4575,
	"./divider.svg": 45774,
	"./doc-illustration.svg": 87953,
	"./document.svg": 6841,
	"./documentation.svg": 29168,
	"./door-open.svg": 57181,
	"./dots.svg": 29647,
	"./dotted-divider.svg": 89979,
	"./download.svg": 92661,
	"./draw-compass.svg": 58562,
	"./duplicate.svg": 39198,
	"./earth.svg": 68562,
	"./ellipse.svg": 42074,
	"./ellipsis.svg": 42224,
	"./embed.svg": 41668,
	"./emoji-picker.svg": 45109,
	"./end-call.svg": 71939,
	"./end-meeting.svg": 68785,
	"./enterprise-plan.svg": 68508,
	"./envelope-open-check.svg": 64133,
	"./envelope.svg": 34585,
	"./envelopes.svg": 56479,
	"./eraser.svg": 1881,
	"./ex.svg": 75012,
	"./excel.svg": 43690,
	"./expand.svg": 54871,
	"./export.svg": 11735,
	"./external-page.svg": 7661,
	"./eye-closed-outline.svg": 69936,
	"./eye-open.svg": 2644,
	"./eye-outline.svg": 54538,
	"./eye.svg": 83275,
	"./face-grin.svg": 33546,
	"./face-plus.svg": 51320,
	"./face-smile-2.svg": 61557,
	"./face-smile.svg": 62788,
	"./facial-recognition.svg": 92711,
	"./figma.svg": 75723,
	"./file-clip.svg": 68633,
	"./file-content.svg": 63947,
	"./file-empty.svg": 16821,
	"./file-play.svg": 51398,
	"./file-zip.svg": 35041,
	"./file.svg": 19765,
	"./files-content.svg": 17583,
	"./files.svg": 65653,
	"./film-play.svg": 52911,
	"./film.svg": 35172,
	"./filter-outline.svg": 42585,
	"./filter.svg": 10416,
	"./fingerprint.svg": 48198,
	"./flag-2.svg": 58725,
	"./flag-alt.svg": 13810,
	"./flag-outline.svg": 57561,
	"./flag.svg": 91840,
	"./folder.svg": 88217,
	"./forklift.svg": 28296,
	"./frame-1.svg": 44579,
	"./frame-2.svg": 49204,
	"./frame.svg": 2240,
	"./free-plan.svg": 27513,
	"./fx-blur.svg": 15790,
	"./gas-pump.svg": 19273,
	"./gauge-3.svg": 76158,
	"./gear-2.svg": 96511,
	"./gear-outline.svg": 36358,
	"./gear.svg": 87554,
	"./gears.svg": 60152,
	"./gem-sparkle.svg": 92838,
	"./generate-new.svg": 35450,
	"./getstarted.svg": 88197,
	"./gif.svg": 99239,
	"./globe.svg": 45074,
	"./go-to.svg": 23313,
	"./golf-flag.svg": 68764,
	"./google-docs.svg": 76486,
	"./google-drawings.svg": 17336,
	"./google-drive.svg": 62486,
	"./google-forms.svg": 82748,
	"./google-maps.svg": 81840,
	"./google-sheets.svg": 29914,
	"./google-slides.svg": 60949,
	"./grab.svg": 59506,
	"./graduation-cap.svg": 95113,
	"./grid-dots.svg": 48093,
	"./grid-layout-11.svg": 122,
	"./grid-minus.svg": 16886,
	"./grid-plus-2.svg": 88945,
	"./grid-plus.svg": 12873,
	"./grid.svg": 20415,
	"./group-call.svg": 28633,
	"./grouping-outline.svg": 59587,
	"./hand-3.svg": 49922,
	"./hand-book-open.svg": 6254,
	"./hand-check.svg": 96837,
	"./hand-outline.svg": 74970,
	"./hand-wave-2.svg": 15,
	"./hand-wave-fill.svg": 81257,
	"./hand-wave.svg": 81373,
	"./hand.svg": 61383,
	"./handle.svg": 29565,
	"./handshake.svg": 98492,
	"./happy-outline.svg": 80331,
	"./happy.svg": 63653,
	"./hashtag.svg": 28506,
	"./heading-1.svg": 50032,
	"./heading-2.svg": 3646,
	"./heading-3.svg": 72997,
	"./headphones-3.svg": 50414,
	"./headset.svg": 91727,
	"./heart-fill.svg": 56568,
	"./heart.svg": 11625,
	"./help-circle-outline.svg": 49104,
	"./help.svg": 75429,
	"./hide-tasks.svg": 61733,
	"./highlight.svg": 30044,
	"./highlighter.svg": 32488,
	"./history.svg": 58766,
	"./hit-enter.svg": 25911,
	"./home-outline.svg": 4208,
	"./home.svg": 77973,
	"./hot-drink.svg": 70336,
	"./hours-24.svg": 7774,
	"./house-5.svg": 24953,
	"./id-badge.svg": 36615,
	"./image.svg": 60086,
	"./images-2.svg": 30041,
	"./inbox-empty.svg": 50033,
	"./inbox-full-fill.svg": 48348,
	"./inbox-full-outline.svg": 7890,
	"./inbox-full.svg": 16578,
	"./inbox-outline.svg": 53471,
	"./inbox.svg": 36703,
	"./incoming-call.svg": 44688,
	"./incoming-large-call.svg": 89945,
	"./indicator.svg": 59856,
	"./information-circle.svg": 70570,
	"./inter.svg": 99031,
	"./invite-others.svg": 53469,
	"./invite-users.svg": 50942,
	"./invited-users.svg": 28018,
	"./italic.svg": 53788,
	"./kanban-view.svg": 72935,
	"./laser.svg": 75554,
	"./last-updated.svg": 42544,
	"./layers-2.svg": 98475,
	"./layout-2.svg": 79853,
	"./layout.svg": 75957,
	"./leaf.svg": 6248,
	"./leave-outline.svg": 30268,
	"./leave.svg": 64563,
	"./left-alignment.svg": 26975,
	"./life-ring.svg": 9013,
	"./lightbulb-2.svg": 82013,
	"./lightbulb-3.svg": 75970,
	"./line-divider.svg": 57059,
	"./link-outline.svg": 27328,
	"./link-plus.svg": 74383,
	"./link-slash.svg": 47891,
	"./link.svg": 86780,
	"./list-illustration.svg": 91464,
	"./list-todo.svg": 16114,
	"./list-view.svg": 11466,
	"./loading.svg": 41398,
	"./lock-outline.svg": 13349,
	"./lock.svg": 43380,
	"./log-out.svg": 37552,
	"./logout-circle.svg": 89683,
	"./logout-outline.svg": 73106,
	"./loom.svg": 4280,
	"./many-tasks.svg": 14051,
	"./mark-as-read.svg": 65309,
	"./maximize-window.svg": 52775,
	"./meeting-video.svg": 60393,
	"./megaphone.svg": 38763,
	"./mention.svg": 39878,
	"./menu.svg": 89925,
	"./message-support.svg": 86349,
	"./message-user.svg": 8851,
	"./mic-off.svg": 85322,
	"./mic.svg": 63312,
	"./microphone-slash.svg": 26417,
	"./microphone.svg": 31859,
	"./minimize-meeting.svg": 46597,
	"./minimize-window.svg": 65159,
	"./minus.svg": 42194,
	"./miro.svg": 51863,
	"./missed-call.svg": 31220,
	"./missed-large-call.svg": 58041,
	"./money.svg": 83697,
	"./mono.svg": 20398,
	"./moon-cloud.svg": 46110,
	"./moon.svg": 17991,
	"./move-down.svg": 35802,
	"./move-up.svg": 94465,
	"./move.svg": 93363,
	"./movie.svg": 23370,
	"./msg-forward.svg": 68279,
	"./msgs.svg": 48176,
	"./music-note-sparkle.svg": 24443,
	"./narrow.svg": 38621,
	"./network-error.svg": 31043,
	"./new-tab.svg": 1575,
	"./new-task.svg": 43215,
	"./new-workspace.svg": 68577,
	"./no-results-found.svg": 93087,
	"./no-results.svg": 35585,
	"./no-users.svg": 16330,
	"./notes.svg": 49426,
	"./nothing.svg": 3513,
	"./notification.svg": 12074,
	"./notifications-outline.svg": 94980,
	"./numbers.svg": 25346,
	"./octagon.svg": 62537,
	"./offline-dash.svg": 24087,
	"./offline.svg": 21483,
	"./ol.svg": 99561,
	"./online.svg": 53340,
	"./oops-robot.svg": 45343,
	"./open-new-tab.svg": 95440,
	"./open-preview.svg": 13031,
	"./open-task.svg": 80571,
	"./options-outline.svg": 56083,
	"./orbit.svg": 4013,
	"./ordered-list.svg": 3762,
	"./org.svg": 97596,
	"./outgoing-call.svg": 65232,
	"./outgoing-large-call.svg": 53803,
	"./oval-fill.svg": 82428,
	"./page-layout.svg": 88098,
	"./page-outline.svg": 32855,
	"./paintbrush.svg": 73059,
	"./paper-plane-outline.svg": 6340,
	"./paper-plane.svg": 72314,
	"./paperclip-2.svg": 10457,
	"./paperclip.svg": 72980,
	"./paragraph.svg": 85025,
	"./party.svg": 68966,
	"./password.svg": 82729,
	"./pause-notifications.svg": 99615,
	"./paused-notifications.svg": 76311,
	"./pdf.svg": 87164,
	"./pen-2.svg": 88880,
	"./pen-3.svg": 49515,
	"./pen-writing-6.svg": 31187,
	"./pen-writing-outline.svg": 31945,
	"./pen-writing.svg": 19736,
	"./pentagon.svg": 12907,
	"./people-app-outline.svg": 99662,
	"./people-app.svg": 77228,
	"./people-outline.svg": 89943,
	"./people.svg": 34584,
	"./person-walking.svg": 33472,
	"./person.svg": 72617,
	"./personal.svg": 15134,
	"./phone-type.svg": 75371,
	"./phone.svg": 75883,
	"./photo-settings.svg": 22235,
	"./photo.svg": 97248,
	"./piggy-bank.svg": 83160,
	"./pin-tack-fill.svg": 90526,
	"./pin-tack-slash.svg": 9469,
	"./pin-tack.svg": 16073,
	"./plane.svg": 74245,
	"./planet.svg": 59826,
	"./plus-circle-outline.svg": 41102,
	"./plus-circle.svg": 13447,
	"./plus.svg": 40863,
	"./pointer.svg": 97515,
	"./power-off.svg": 11712,
	"./powerpoint-ms.svg": 59803,
	"./powerpoint.svg": 99791,
	"./pptx.svg": 9944,
	"./presentation-line.svg": 21134,
	"./presentation.svg": 23093,
	"./preview.svg": 98071,
	"./print.svg": 56483,
	"./private.svg": 78305,
	"./progress.svg": 44603,
	"./puzzle-piece.svg": 79643,
	"./quote.svg": 59169,
	"./raising-hand.svg": 65997,
	"./random-unsplash.svg": 51813,
	"./rating.svg": 2481,
	"./refresh-2.svg": 58126,
	"./refresh-clockwise.svg": 5834,
	"./reminders.svg": 56775,
	"./report-issue.svg": 74291,
	"./reposition-photo.svg": 53760,
	"./reposition-y.svg": 53985,
	"./reposition.svg": 83670,
	"./resend-invite.svg": 47157,
	"./reset-password.svg": 69467,
	"./reset.svg": 31561,
	"./restore.svg": 39334,
	"./rhombus-fill.svg": 71572,
	"./rhombus-flip.svg": 5143,
	"./ribbon.svg": 49986,
	"./right-alignment.svg": 92913,
	"./rocket.svg": 88034,
	"./rotate-image-clockwise.svg": 74408,
	"./route.svg": 73599,
	"./row-after.svg": 51196,
	"./row-before.svg": 84221,
	"./rows.svg": 77778,
	"./ruler-pen.svg": 83951,
	"./scale.svg": 56909,
	"./schedule-message-clock.svg": 31921,
	"./schedule-message.svg": 41327,
	"./school.svg": 45979,
	"./scissors.svg": 58934,
	"./screen-sharing.svg": 88009,
	"./screenshare.svg": 21290,
	"./search-outline.svg": 71009,
	"./search.svg": 8193,
	"./select.svg": 48736,
	"./selfie.svg": 48016,
	"./send.svg": 19514,
	"./serif.svg": 22731,
	"./setaway.svg": 71109,
	"./settings-outline.svg": 68843,
	"./shape-circle.svg": 93088,
	"./shape-hexagon.svg": 21013,
	"./shape-hexagon1.svg": 68746,
	"./shape-line.svg": 11957,
	"./shape-square.svg": 91927,
	"./shape-triangle.svg": 21253,
	"./share-screen.svg": 24624,
	"./share-up-right.svg": 76204,
	"./share.svg": 60581,
	"./sharepoint.svg": 88778,
	"./shield-check.svg": 8064,
	"./shoe-sneakers.svg": 7773,
	"./shop.svg": 23819,
	"./show-all-features.svg": 55674,
	"./show-fields.svg": 94162,
	"./show-tasks.svg": 47066,
	"./shuffle.svg": 52850,
	"./sidebar-hide.svg": 59526,
	"./sidebar-left-4.svg": 92553,
	"./sidebar-left.svg": 45266,
	"./sidebar-show.svg": 28348,
	"./sign-up.svg": 12655,
	"./sketch.svg": 18729,
	"./sleeping-time.svg": 11359,
	"./sliders.svg": 32471,
	"./smile.svg": 87582,
	"./smiling-emoji.svg": 522,
	"./sort-arrows.svg": 97860,
	"./sort-outline.svg": 86893,
	"./sort.svg": 33552,
	"./sorting-outline.svg": 86436,
	"./space.svg": 9674,
	"./sparkle-3.svg": 52529,
	"./split-pane.svg": 58407,
	"./spreadsheet.svg": 8944,
	"./square-activity-chart.svg": 60141,
	"./square-brackets.svg": 22717,
	"./square-code.svg": 54162,
	"./square-command.svg": 47903,
	"./square-dashed-plus.svg": 86028,
	"./square-dashed-sparkle.svg": 92931,
	"./square-kanban.svg": 19330,
	"./square-plus.svg": 63568,
	"./square-xmark.svg": 57340,
	"./square.svg": 88590,
	"./stack-perspective.svg": 6251,
	"./star-fill.svg": 94113,
	"./star-outline.svg": 15956,
	"./star.svg": 51014,
	"./sticker-smile.svg": 27302,
	"./sticker-square.svg": 62897,
	"./storage.svg": 16449,
	"./strikethrough.svg": 3520,
	"./string-contains.svg": 17863,
	"./stroke-projecting-cap.svg": 89911,
	"./subtask.svg": 47855,
	"./suit-diamonds.svg": 7073,
	"./suitcase-3.svg": 44183,
	"./suitcase.svg": 60623,
	"./sun.svg": 33161,
	"./sunglasses.svg": 75645,
	"./support.svg": 75857,
	"./symbols.svg": 30602,
	"./system.svg": 7140,
	"./table-illustration.svg": 58936,
	"./table-rows-3.svg": 85258,
	"./table-view.svg": 71866,
	"./table.svg": 85215,
	"./tag-outline.svg": 26728,
	"./tag.svg": 57290,
	"./tags-outline.svg": 44941,
	"./tags.svg": 83111,
	"./tally-forms.svg": 74513,
	"./target-outline.svg": 35155,
	"./target.svg": 80526,
	"./task-list.svg": 47443,
	"./task-today.svg": 10368,
	"./taskorbiter.svg": 79757,
	"./tasks-2.svg": 63232,
	"./tasks-complete.svg": 90966,
	"./tasks-outline.svg": 57480,
	"./tasks.svg": 69598,
	"./team-plan.svg": 6284,
	"./text-a.svg": 26023,
	"./text-align-left.svg": 75508,
	"./text-outline.svg": 25671,
	"./text-tool.svg": 80535,
	"./text.svg": 16829,
	"./themes.svg": 55778,
	"./thick-divider.svg": 66669,
	"./thinking.svg": 54858,
	"./thread.svg": 29456,
	"./ticket.svg": 71956,
	"./time.svg": 1183,
	"./today-outline.svg": 92969,
	"./toggle-commands.svg": 90057,
	"./tomorrow.svg": 66201,
	"./topic.svg": 67215,
	"./trapezoid.svg": 28309,
	"./trash-outline.svg": 60615,
	"./trash.svg": 91642,
	"./treasure-map.svg": 24585,
	"./trial-warning.svg": 27185,
	"./triangle-warning.svg": 38865,
	"./typeform-logo.svg": 96362,
	"./typing.svg": 62986,
	"./typography.svg": 5093,
	"./ul.svg": 15108,
	"./underline.svg": 86568,
	"./undo.svg": 73473,
	"./unordered-list.svg": 30747,
	"./upgrade-workspace.svg": 49780,
	"./upgrade.svg": 36016,
	"./upload-from.svg": 70812,
	"./upload-icons.svg": 63692,
	"./upload.svg": 98740,
	"./user-ban.svg": 63680,
	"./user-circle.svg": 78111,
	"./user-gallery.svg": 69890,
	"./user-outline.svg": 86002,
	"./user-plus.svg": 29063,
	"./user-settings.svg": 11047,
	"./user.svg": 19622,
	"./users-2.svg": 40059,
	"./users-fill.svg": 274,
	"./users-plus.svg": 24314,
	"./users-shaking-hands.svg": 22165,
	"./users.svg": 73724,
	"./uturn-left.svg": 64641,
	"./uturn-right.svg": 4809,
	"./vacation.svg": 73997,
	"./vault-3.svg": 69075,
	"./verify-email.svg": 69223,
	"./versions.svg": 2594,
	"./video-fill.svg": 95435,
	"./video-off.svg": 56184,
	"./video-outline.svg": 69371,
	"./video.svg": 16453,
	"./view-all.svg": 10600,
	"./view-dash.svg": 94028,
	"./views-outline.svg": 4338,
	"./views.svg": 11759,
	"./vimeo.svg": 20910,
	"./visio.svg": 45310,
	"./volume-disabled.svg": 68125,
	"./volume-up.svg": 46257,
	"./wallet-2.svg": 94270,
	"./wand-sparkle.svg": 90972,
	"./wand.svg": 4343,
	"./waveform-lines.svg": 20762,
	"./webcam.svg": 55149,
	"./website.svg": 86043,
	"./whiteboard-illustration.svg": 56185,
	"./whiteboard.svg": 36215,
	"./wide.svg": 96397,
	"./width-max.svg": 59307,
	"./width-min.svg": 66691,
	"./window-chart-line.svg": 51347,
	"./window-full-screen.svg": 70328,
	"./word-doc.svg": 43288,
	"./word.svg": 94576,
	"./work.svg": 86844,
	"./workspace.svg": 48687,
	"./workstation.svg": 24480,
	"./wrench.svg": 93224,
	"./xlogo.svg": 85909,
	"./xmark.svg": 84948,
	"./youtube.svg": 7314,
	"./zip.svg": 58981
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87254;